// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import AccountSettingsState from "@insite/client-framework/Store/Pages/AccountSettings/AccountSettingsState";
import AccountSettingsStateExtension from "@store/Extensions/Store/Pages/AccountSettings/AccountSettingsState";
import { ExtendState } from "@toolkit/Framework/Types/ReduxActions";
import { Draft } from "immer";

const initialState: ExtendState<AccountSettingsState, AccountSettingsStateExtension> = {
    firstNameErrorMessage: "",
    lastNameErrorMessage: "",
    phoneErrorMessage: "",
};

const actions = {
    "Store/Pages/AccountSettings/UpdateAccountSettings": (
        draft: Draft<AccountSettingsState>,
        action: {
            firstName?: string;
            firstNameErrorMessage?: string;
            lastName?: string;
            lastNameErrorMessage?: string;
            phone?: string;
            phoneErrorMessage?: string;
        },
    ) => {
        if (!draft.editingAccount) {
            return;
        }

        if (typeof action.firstName !== "undefined") {
            draft.editingAccount.firstName = action.firstName;
            draft.firstNameErrorMessage = action.firstNameErrorMessage;
        }

        if (typeof action.lastName !== "undefined") {
            draft.editingAccount.lastName = action.lastName;
            draft.lastNameErrorMessage = action.lastNameErrorMessage;
        }

        if (typeof action.phone !== "undefined") {
            draft.editingAccount.properties.phone = action.phone;
            draft.phoneErrorMessage = action.phoneErrorMessage;
        }
    },
};

const reducer = createTypedReducerWithImmer(initialState as AccountSettingsState, actions);
export type AccountSettingsActions = Parameters<typeof reducer>[1];
export default reducer;
